module.exports = __webpack_public_path__ + "img/lucbro.9a0cfe6f.png";